export const ReportFormat = {
  WORD: 0,
  PDF: 1,
};
